import { render } from "./DocumentLayoutLeftSvg.vue?vue&type=template&id=7d15ef56"
import script from "./DocumentLayoutLeftSvg.vue?vue&type=script&lang=js"
export * from "./DocumentLayoutLeftSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__